import React, { useEffect, useState } from "react";
import { BookOpenIcon, GiftIcon, GlobeIcon, FlameIcon, CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { Countdown } from "./Countdown";
import { bonuses, images } from "../data/content";
const TOTAL_SPOTS = 100;
export function Offer() {
  const [spotsLeft, setSpotsLeft] = useState(9);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSpotsLeft(s => s > 3 ? s - 1 : s);
    }, 45000);
    return () => window.clearInterval(id);
  }, []);
  const filled = (TOTAL_SPOTS - spotsLeft) / TOTAL_SPOTS * 100;
  return <section id="offer" className="bg-night px-4 py-16 sm:px-6 sm:py-20" data-id="element-195" data-mp="13xavdayffh5n">
      <div className="mx-auto max-w-2xl" data-id="element-196" data-mp="yy7r3sq9teyq">
        <p className="text-center text-sm font-bold uppercase tracking-wider text-gold" data-id="element-197" data-mp="yx52xskc1qmi">Your special launch offer</p>
        <h2 className="mt-2 text-center font-display text-[30px] font-extrabold leading-[1.1] text-white sm:text-5xl" data-id="element-198" data-mp="2fad3dhmgmye7">
          Here's Everything You'll Receive Today
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white" data-id="element-199" data-mp="pjfmagfjuxlt">
          <img src={images.mockup} alt="Complete CAN Bus Diagnostic Blueprint bundle" className="w-full" data-id="element-200" data-mp="uise7fla2uv9" />

          <div className="px-5 pb-8 sm:px-8" data-id="element-201" data-mp="zi53e6zmge10">
            <div className="flex gap-3 border-b border-ink/10 pb-5" data-id="element-202" data-mp="zgafcjt205sp">
              <BookOpenIcon className="mt-1 h-6 w-6 shrink-0 text-brand" aria-hidden="true" data-id="element-203" data-mp="13ip1pdvxlnoq" />
              <div className="flex-1" data-id="element-204" data-mp="6v0sxmhrf7hu">
                <div className="flex items-start justify-between gap-3" data-id="element-205" data-mp="6rwgk1u555g3">
                  <h3 className="font-display text-lg font-extrabold leading-snug text-ink" data-id="element-206" data-mp="btc0fqkl15ww">
                    CAN Bus Diagnostic Blueprint™ — 6-Volume Collection
                  </h3>
                  <span className="shrink-0 font-bold text-ink-muted line-through" data-id="element-207" data-mp="klxj76o7rclq">$97</span>
                </div>
                <p className="mt-1 text-sm leading-relaxed text-ink-soft" data-id="element-208" data-mp="3k8dmwz0ysrps">
                  Complete visual workflow system, investigation framework, evidence trackers, decision tools, and
                  case documentation templates.
                </p>
              </div>
            </div>

            <ul className="divide-y divide-ink/10" data-id="element-209" data-mp="qg4hvn3mnmgr">
              {bonuses.map(b => <li key={b.number} className="flex items-start gap-3 py-3.5" data-id="element-210" data-mp="1548vwdrqj9t7">
                  <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-211" data-mp="1067ctsub7ahq" />
                  <span className="flex-1 text-[15px] font-semibold leading-snug text-ink" data-id="element-212" data-mp="cg38tkd7l8q7">{b.title}</span>
                  <span className="shrink-0 text-sm font-bold text-ink-muted line-through" data-id="element-213" data-mp="7itmidl49d6l">${b.value}</span>
                </li>)}
            </ul>

            <div className="mt-2 rounded-2xl bg-canvas px-4 py-4 text-center" data-id="element-214" data-mp="hfzdlltqd46t">
              <p className="text-sm font-semibold uppercase tracking-wide text-ink-muted" data-id="element-215" data-mp="hi2ckvcv27no">Total reference value</p>
              <p className="font-display text-3xl font-black text-alert line-through" data-id="element-216" data-mp="1sv4t5qeymx7u">$254</p>
            </div>

            <div className="mt-6 text-center" data-id="element-217" data-mp="20ex6txk71lsg">
              <p className="font-display text-lg font-bold text-ink" data-id="element-218" data-mp="20d2nuoshg3r0">Today, get everything for just…</p>
              <p className="mt-1 font-display text-[80px] font-black leading-none text-cta sm:text-[96px]" data-id="element-219" data-mp="25fbf9gppixr0">
                $27
              </p>
              <p className="mt-1 text-sm font-bold uppercase tracking-wide text-ink" data-id="element-220" data-mp="1vfat7n0ge3j4">USD · One-time payment</p>
            </div>

            <p className="mx-auto mt-5 flex max-w-md items-center justify-center gap-2 rounded-xl bg-brand-light px-4 py-3 text-center text-sm font-semibold text-brand-dark" data-id="element-221" data-mp="2j66jugt6asos">
              <GlobeIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-222" data-mp="29fveqqxr6dgb" />
              Currency is converted automatically to your local currency at checkout.
            </p>

            <ul className="mx-auto mt-6 grid max-w-md gap-2.5 text-[15px] text-ink sm:grid-cols-2" data-id="element-223" data-mp="323zn5k7pl4mp">
              {["Instant digital access", "Lifetime access", "No monthly subscriptions", "Six core volumes", "Five exclusive bonuses", "7-day money-back guarantee"].map(f => <li key={f} className="flex items-center gap-2" data-id="element-224" data-mp="1e9o0w6b48dg1">
                  <CheckIcon className="h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-225" data-mp="198qjvx1udpg4" />
                  {f}
                </li>)}
            </ul>

            <div className="mt-8 rounded-2xl border-2 border-alert/30 bg-alert-light/60 p-4" data-id="element-226" data-mp="21xfc16kx6kfq">
              <p className="flex items-center justify-center gap-2 text-center text-[15px] font-bold text-alert" data-id="element-227" data-mp="1wx9i1jr6gluh">
                <FlameIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-228" data-mp="1s6b24la3pprr" />
                Only {spotsLeft} spots left at the promotional price!
              </p>
              <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuemin={0} aria-valuemax={TOTAL_SPOTS} aria-valuenow={TOTAL_SPOTS - spotsLeft} aria-label="Promotional spots claimed" data-id="element-229" data-mp="2kndlnr4d8llh">
                <div className="flex h-full animate-pulsebar items-center justify-end rounded-full bg-alert pr-2 transition-[width] duration-300 ease-out" style={{
                width: `${filled}%`
              }} data-id="element-230" data-mp="2s7xw3cexndxy">
                  <span className="text-[11px] font-bold text-white" data-id="element-231" data-mp="322pugigca4ts">{Math.round(filled)}% claimed</span>
                </div>
              </div>
            </div>

            <div className="mt-8" data-id="element-232" data-mp="3b4fw0h3xqk5a">
              <CtaButton label="Yes! Give me instant access for $27" data-id="element-233" data-mp="3b3e9nghgyb89" />
            </div>
            <p className="mt-4 text-center text-sm text-ink-muted" data-id="element-234" data-mp="3fyk5p84l56a2">
              One-Time Payment · Instant Download · 7-Day Money-Back Guarantee
            </p>

            <Countdown data-id="element-235" data-mp="3pvpuuatn2n7n" />

            <p className="mt-6 text-center text-xs leading-relaxed text-ink-muted" data-id="element-236" data-mp="3pwhtjuij9125">
              Any reference values shown are pricing estimates for the individual components, not evidence of
              previous sales at those prices.
            </p>
          </div>
        </div>
      </div>
    </section>;
}